import {
  getDateRange,
  getOption,
  toDateRangeParams,
  type FilterValues,
} from "@/ui/filters/filterValues";

export const toVoucherFilterParams = (values: FilterValues) => ({
  ...toDateRangeParams(getDateRange(values, "date")),
  productApplicantId: getOption(values, "applicant")?.value,
  costCenterId: getOption(values, "costCenter")?.value,
  workOrderId: getOption(values, "workOrder")?.value,
});
